import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "section"
}
const _hoisted_2 = { class: "cards-grid" }
const _hoisted_3 = {
  key: 0,
  class: "load-more-container"
}

import { ref, computed, nextTick } from "vue";
import LotteryCard from "@/components/LotteryCard.vue";
import SectionHeader from "@/components/base/SectionHeader.vue";
import type { UpcomingDraw } from '@/types/lottery';
import { iframeCommunication } from "@/utils/iframeCommunication";
import { useIntegrationMode } from '@/composables/useIntegrationMode';


const __default__ = {
  name: 'FavoritesSection'
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    favorites: {},
    isFavorited: { type: Function }
  },
  emits: ["favorite", "bet", "remove"],
  setup(__props: any, { emit: __emit }) {

const { isLite } = useIntegrationMode();

const props = __props

const emit = __emit

const displayLimit = ref(10);

const displayedFavorites = computed(() => {
  return props.favorites.slice(0, displayLimit.value);
});

const hasMore = computed(() => {
  return props.favorites.length > displayLimit.value;
});

const loadMore = () => {
  displayLimit.value += 10;
  nextTick(() => {
    setTimeout(() => {
      iframeCommunication.sendImmediateHeightUpdate();
    }, 100);
  });
};

const handleBet = (lottery: UpcomingDraw) => {
  emit('bet', lottery);
};

return (_ctx: any,_cache: any) => {
  return (!_unref(isLite) && _ctx.favorites && _ctx.favorites.length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          _createVNode(SectionHeader, {
            title: _ctx.$t('sections.favourites'),
            variant: "simple"
          }, null, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedFavorites.value, (game) => {
            return (_openBlock(), _createBlock(LotteryCard, {
              key: game.id,
              lottery: game,
              layout: "horizontal",
              "is-favorited": _ctx.isFavorited,
              onFavorite: () => _ctx.$emit('favorite', game),
              onBet: ($event: any) => (handleBet(game)),
              onRemove: () => _ctx.$emit('remove', game)
            }, null, 8, ["lottery", "is-favorited", "onFavorite", "onBet", "onRemove"]))
          }), 128))
        ]),
        (hasMore.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "load-more-button",
                onClick: loadMore
              }, _toDisplayString(_ctx.$t('forms.loadMoreNumberGames')), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})